export default "__VITE_ASSET__BpEu4t5I__"